import common from './modules/common'

export default {
  common,
}



// WEBPACK FOOTER //
// ./src/store/common/index.js